if (!customElements.get('promotion-slider')) {
  class PromotionSlider extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.swiper');
      this.sliderWrapper = this.querySelector('.promotion');
      if (!this.swiperEl || !this.sliderWrapper || this.sliderInstance) return;

      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.initSlider();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = null;
      }
    }

    initSlider() {
      const desktop = parseInt(this.dataset.slidesDesktop, 10) || 6;
      const tablet = parseInt(this.dataset.slidesTablet, 10) || Math.min(desktop, 4);
      const mobile = parseInt(this.dataset.slidesMobile, 10) || 2;
      const gap = parseInt(this.dataset.gap, 10) || 0;
      const gapMobile = parseInt(this.dataset.gapMobile, 10);
      const spaceMobile = Number.isNaN(gapMobile) ? gap : gapMobile;
      const slideCount = this.sliderWrapper.children.length;
      const maxPerView = Math.max(desktop, tablet, mobile);
      const canLoop = this.dataset.loop === 'true' && slideCount > maxPerView;
      const reduceMotion =
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        (window.FoxTheme && FoxTheme.config.motionReduced);
      const autoplayEnabled = this.dataset.autoplay === 'true' && !reduceMotion;
      const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 4000;
      const paginationEl = this.querySelector('.swiper-pagination');
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');

      const modules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination];
      if (autoplayEnabled) modules.push(FoxTheme.Swiper.Autoplay);

      const options = {
        modules,
        slidesPerView: mobile,
        spaceBetween: spaceMobile,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        loop: canLoop,
        threshold: 2,
        speed: 450,
        navigation:
          nextEl && prevEl
            ? {
                nextEl,
                prevEl,
              }
            : false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        autoplay: autoplayEnabled
          ? {
              delay: autoplayDelay,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: tablet,
            spaceBetween: gap,
          },
          990: {
            slidesPerView: desktop,
            spaceBetween: gap,
          },
        },
      };

      this.canLoop = canLoop;
      this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, options);
      this.sliderInstance.init();
    }

    onBlockSelect(event) {
      if (!this.sliderInstance || !this.sliderInstance.slider) return;
      if (event.detail.sectionId !== this.dataset.sectionId) return;

      const slide = event.target.closest('.swiper-slide');
      if (!slide || !this.contains(slide)) return;

      const index = Number(slide.dataset.index);
      if (Number.isNaN(index)) return;

      if (this.canLoop) {
        this.sliderInstance.slider.slideToLoop(index);
      } else {
        this.sliderInstance.slider.slideTo(index);
      }
    }
  }

  customElements.define('promotion-slider', PromotionSlider);
}
